var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pie-chart',{attrs:{"title":"Répartition de l'utilisation","subTitle":"des outils et modules","series":_vm.series,"labels":_vm.labels,"loading":_vm.loading,"colors":_vm.colors}})}
var staticRenderFns = []

export { render, staticRenderFns }